import axios, { AxiosError } from 'axios';

export const isAxiosError = (
  err: unknown,
): err is AxiosError => err instanceof Error && axios.isAxiosError(err);